import { render, staticRenderFns } from "./InterTableLoading.vue?vue&type=template&id=c13d51d6&scoped=true"
import script from "./InterTableLoading.vue?vue&type=script&lang=js"
export * from "./InterTableLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13d51d6",
  null
  
)

export default component.exports